import { render, staticRenderFns } from "./DnsOptions.vue?vue&type=template&id=768994e8&scoped=true"
import script from "./DnsOptions.vue?vue&type=script&lang=js"
export * from "./DnsOptions.vue?vue&type=script&lang=js"
import style0 from "./DnsOptions.vue?vue&type=style&index=0&id=768994e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768994e8",
  null
  
)

export default component.exports